import React from 'react';

export const MAIN_CAMPUS_ONLY_MESSAGE = 'こちらの機能は基本プラン限定になります';

export function isCorrespondenceUser(user) {
  return (user?.campus_type || user?.campusType) === 'correspondence';
}

export default function MainCampusOnly({ locked, children, className = '' }) {
  return (
    <div className={`relative ${className}`}>
      <div className={locked ? 'pointer-events-none select-none grayscale opacity-40' : ''}>
        {children}
      </div>
      {locked && (
        <div className="absolute inset-0 z-10 flex items-center justify-center rounded-2xl bg-zinc-100/70 px-3 text-center backdrop-blur-[1px] sm:px-4">
          <p className="max-w-[min(100%,32rem)] rounded-2xl bg-white/95 px-4 py-2 text-base font-semibold leading-relaxed text-[#5d4529] shadow-sm ring-1 ring-[#d4c4b0] sm:rounded-full sm:px-6 sm:py-3 sm:text-xl lg:text-2xl">
            {MAIN_CAMPUS_ONLY_MESSAGE}
          </p>
        </div>
      )}
    </div>
  );
}
